// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { TaskSquare, Category } from 'iconsax-react';

// icons — one relevant icon per destination
const icons = {
  tickets: TaskSquare,
  all: Category,
};

// ==============================|| MENU ITEMS - TICKETS ||============================== //
// Top-level Tickets section: an "All tickets" overview plus one item per active
// workflow (the per-workflow screens are injected at runtime in the Navigation
// component from getWorkflows). Sits between Dashboard and User Management.

// "All tickets" across workflows — only worth showing to someone in more than
// one workflow (Navigation drops it otherwise).
export const allTicketsItem = {
  id: 'tickets-all',
  title: <FormattedMessage id="All Tickets" />,
  type: 'item',
  icon: icons.all,
  url: '/tickets/list',
};

const tickets = {
  id: 'group-tickets',
  title: <FormattedMessage id="Tickets" />,
  icon: icons.tickets,
  type: 'group',
  children: [
    allTicketsItem,
    // one item per workflow injected at runtime
  ],
};

export default tickets;
